import axios from "axios";
import { Copy, ExternalLink, MapPin, Clock } from "lucide-react";
import { toast } from "sonner";
import { API, timeAgo } from "@/lib/api";
import { TypeBadge } from "@/components/TypeBadge";

export const BonusCard = ({ bonus, testid, compact = false }) => {
  const copy = () => {
    navigator.clipboard?.writeText(bonus.promo_code);
    toast.success(`Code ${bonus.promo_code} copied`);
  };
  const claim = () => {
    axios.post(`${API}/bonuses/${bonus.id}/click`).catch(() => {});
    window.open(bonus.link, "_blank", "noopener");
  };
  return (
    <article data-testid={testid} className="group relative rounded-2xl bg-[#151B28] border border-white/[0.07] p-6 hover:border-emerald-500/40 hover:shadow-[0_0_24px_rgba(16,185,129,0.15)] transition-[border-color,box-shadow] duration-300 flex flex-col gap-4">
      <div className="flex items-start justify-between gap-3">
        <div>
          <TypeBadge type={bonus.bonus_type} />
          <h3 className="mt-3 text-lg font-bold text-white">{bonus.casino}</h3>
        </div>
        <span className="font-mono text-xl font-bold gold-text whitespace-nowrap" data-testid={`${testid}-value`}>{bonus.value}</span>
      </div>
      <p className="text-slate-200 font-semibold leading-snug">{bonus.title}</p>
      {!compact && bonus.instructions && <p className="text-sm text-slate-400 leading-relaxed">{bonus.instructions}</p>}
      <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-slate-500 font-mono">
        <span className="flex items-center gap-1"><MapPin size={12} />{bonus.states}</span>
        <span className="flex items-center gap-1"><Clock size={12} />Verified {timeAgo(bonus.updated_at)}</span>
        {bonus.expires && <span>Ends {bonus.expires}</span>}
      </div>
      <div className="mt-auto flex gap-2 pt-2">
        {bonus.promo_code && (
          <button onClick={copy} data-testid={`${testid}-copy-btn`} className="flex items-center gap-2 rounded-full border border-dashed border-amber-500/50 px-4 py-2 font-mono text-sm text-amber-300 hover:bg-amber-500/10 transition-colors">
            <Copy size={14} />{bonus.promo_code}
          </button>
        )}
        <button onClick={claim} data-testid={`${testid}-claim-btn`} className="flex-1 flex items-center justify-center gap-2 rounded-full bg-emerald-500 hover:bg-emerald-400 text-[#07090E] font-bold text-sm px-4 py-2 transition-colors">
          Claim Now <ExternalLink size={14} />
        </button>
      </div>
    </article>
  );
};
